module.exports = __webpack_public_path__ + "assets/drop_down_arrow-5e4f9f.svg";